import {gql} from '@apollo/client';

export const CheckInvitationsByChildIdsQuery = gql`
    query CheckInvitationsByChildIds($childIds: [ChildId!]!) {
        roles {
            invitations {
                listByChildIds(childIds: $childIds) {
                    result {
                        childId
                        invitations {
                            roleInvitationId
                            roleTitle
                            roleId
                            ... on ChildContactRoleInvitation {
                                relationId
                                childName {
                                    fullName
                                }
                            }
                            __typename
                        }
                        __typename
                    }
                }
            }
        }
    }
`;
